<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-card>
        <v-card-title class="grey">
          {{ $t("menu.gen_student_id_graduate") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                outlined
                dense
                small
                label="เลขที่ผู้สมัคร"
                placeholder="* กรอกแล้วกด enter เพื่อดูข้อมูลเพิ่มเติม"
                v-model="register_id"
                @keyup.enter="get_register_details"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card
            v-if="register_id && register_level_id"
            color="blue lighten-4"
          >
            <v-row>
              <v-col cols="12" md="12">
                <v-card-title class="text-h5"> ข้อมูลผู้สมัคร </v-card-title>
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" md="4">
                      ชื่อ :
                      <span class="white">
                        {{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
                      </span>
                    </v-col>
                    <v-col cols="12" md="8">
                      ระดับ :
                      <span class="white">
                        {{ register_level_name_th }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      โครงการ :
                      <span class="white">
                        {{ register_project }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      หลักสูตร :
                      <span class="white">
                        {{ register_curriculum_full }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-card-text>
          <h2 class="deep-orange--text text--darken3 mb-4">
            ต้องการนำนักศึกษา ที่กำลังศึกษาระดับปริญญาตรี เข้าสู่
            ระบบลงทะเบียนโครงการแววนวัตกร
          </h2>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                outlined
                dense
                small
                label="รหัสนักศึกษา"
                v-model="student_id"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-col cols="12" md="3">
          ตอนนี้ได้แต่ ระดับ 4+1
        </v-col> -->
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="level_id_graduate"
                label="ระดับ"
                v-bind:items="levels_graduate"
                v-bind:item-value="(item) => item.level_id_graduate"
                v-bind:item-text="
                  (item) =>
                    inlineTranslator({
                      en: item.level_name_en,
                      th: item.level_name_th,
                    })
                "
                clearable
                outlined
                dense
                @change="(e) => update_study_plan(e)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                type="number"
                min="2500"
                max="2600"
                outlined
                dense
                small
                label="ปีการศึกษา"
                v-model="year_graduate"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                type="number"
                min="1"
                max="3"
                outlined
                dense
                small
                label="ภาคการศึกษา"
                v-model="semester_graduate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="registrar_faculty_id"
                label="คณะ"
                v-bind:items="registrar_faculties"
                v-bind:item-value="(item) => item.faculty_id"
                v-bind:item-text="
                  (item) =>
                    inlineTranslator({
                      en: item.faculty_name_en,
                      th: item.faculty_name_th,
                    })
                "
                clearable
                outlined
                dense
                @change="(e) => update_faculty(level_id_graduate, e)"
              ></v-autocomplete>
              <v-autocomplete
                v-model="registrar_curriculum_id"
                label="หลักสูตร"
                v-bind:items="
                  listFilter(
                    registrar_curriculums,
                    registrar_faculty_id,
                    'faculty_id'
                  )
                "
                v-bind:item-value="(item) => item.curriculum_id"
                v-bind:item-text="
                  (item) =>
                    inlineTranslator({
                      en: item.curriculum_name_en,
                      th: item.curriculum_name_th,
                    }) +
                    ' ' +
                    item.year_graduate
                "
                outlined
                dense
              ></v-autocomplete>
              <v-autocomplete
                v-model="study_plan_id"
                label="แผน"
                v-bind:items="study_plans"
                v-bind:item-value="(item) => item.STUDY_PLAN_ID"
                v-bind:item-text="
                  (item) => objectTranslator(item, 'STUDY_PLAN_NAME')
                "
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-btn
          v-if="year_graduate && semester_graduate && student_id"
          color="indigo"
          class="ml-5 white --text"
          @click="get_all_gen_student_id_to()"
        >
          ยืนยันการย้ายผู้สมัครสู่การเป็นนักศึกษา สจล.
        </v-btn>
        <br />
      </v-card>
    </v-container>

    <v-dialog max-width="600" v-model="open_lock_confirm">
      <v-card>
        <v-card-title>ยืนยันการย้ายผู้สมัครสู่การเป็นนักศึกษา สจล.</v-card-title
        ><v-card-text>
          เลขที่ใบสมัคร : {{ register_id }}
          <br />
          {{ " สาขา " + register_curriculum_full }}
          <br />
          <span class="red--text text--lighten-1">
            ต้องการนำเข้าระบบ ให้มีรหัสนักศึกษา
          </span>
          <br />
          <br />
          <span class="green--text text--lighten-1">
            {{ student_id }} ปี/เทอม {{ year }}/{{
              semester_graduate + CURRICULUM_NAME_TO
            }}
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            color="green"
            @click="confirm_gen_student_id_graduate(true)"
            >ยืนยัน</v-btn
          >
          <v-btn
            outlined
            color="red"
            class="ml-4"
            @click="(e) => (open_lock_confirm = false)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import CentralProvider from "@/services/central.provider";
import GenericProvider from "@/services/generic.provider";
import ConfigProvider from "@/services/config.provider";
import { listFilter, getById } from "@/helper/filter";
import RefProvider from "@/services/ref.provider";
import PayInSlipProvider from "@/services/pay_in_slip.provider";
import AuthProvider from "@/services/auth.provider";

import Vue from "vue";
import JsonExcel from "vue-json-excel";
// import downloadexcel from "vue-json-excel";
// import axios from "axios";

Vue.component("downloadExcel", JsonExcel);

const centralService = new CentralProvider();
const genericProvider = new GenericProvider();
const configProvider = new ConfigProvider();
const refProvider = new RefProvider();
const payInSlipService = new PayInSlipProvider();
const authProvider = new AuthProvider();

export default {
  name: "GenStudentID",

  data: () => ({
    level_id_move_to_marticulation_online: null,
    year_id_move_to_marticulation_online: null,
    register_id_data: null,
    year_move_to_marticulation_online: null,
    semester_move_to_marticulation_online: null,
    // student_id_head: null,

    levels_move_to_marticulation_online: [
      {
        level_id_move_to_marticulation_online: "1",
        level_name_en: "ปริญญาตรี",
        level_name_th: "ปริญญาตรี",
      },
      {
        level_id_move_to_marticulation_online: "2",
        level_name_en: "ปริญญาโท",
        level_name_th: "ปริญญาโท",
      },
      {
        level_id_move_to_marticulation_online: "3",
        level_name_en: "ปริญญาเอก",
        level_name_th: "ปริญญาเอก",
      },
    ],

    //=============== Gen student ID =========================
    level_id: null,
    year_id: null,
    mode_id: null,
    years: [],
    student_id_data: null,
    year: null,
    semester: null,
    format: null,
    json_data: [],
    // student_id_head: null,

    levels: [
      {
        level_id: "1",
        level_name_en: "ปริญญาตรี",
        level_name_th: "ปริญญาตรี",
      },
      {
        level_id: "2",
        level_name_en: "บัณฑิตศึกษา",
        level_name_th: "บัณฑิตศึกษา",
      },
    ],
    modes: [
      {
        mode_id: "check",
        mode_name_en: "1. Check student ID details",
        mode_name_th: "1. ตรวจสอบการสร้างรหัส",
      },
      {
        mode_id: "real",
        mode_name_en: "2. Genarate student ID",
        mode_name_th: "2. สร้างรหัสนักศึกษา",
      },
    ],
    json_fields: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    //=============== Gen student ID 4+1=========================
    // mode: "group",
    register_id: null,
    register_uid: null,

    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    register_project: null,
    register_level_name_th: null,
    register_level_name_en: null,
    register_curriculum: null,
    register_curriculum_full: null,
    martriculation_student_status: null,
    levels_graduate: [
      {
        level_id_graduate: "4",
        level_name_en: "4+1",
        level_name_th: "4+1",
      },
    ],
    level_id_graduate: null,
    level_id_fake: null,
    year_graduate: null,
    semester_graduate: null,
    student_id: null,
    study_plan_id: null,

    open_lock_confirm: false,
    registrar_faculties: [],
    registrar_curriculums: [],
    study_plans: [],
    register_level_id: null,
    registrar_faculty_id: null,
    registrar_curriculum_id: null,

    CURRICULUM_NAME_TO: null,
    //-แบบทั้งกลุ่ม
    group_level_id: 2,
    group_year_id: null,
    group_round_id: null,
    group_project_id: null,
    group_curriculum_id: null,
    group_last_level_id: null,
    group_last_year: null,
    group_last_semester: null,

    group_levels: [],
    group_years: [],
    group_rounds: [],
    group_projects: [],
    group_curriculums: [],
  }),

  methods: {
    objectTranslator,
    inlineTranslator,
    listFilter,
    getById,

    //===========================================================
    async update_level(level_id) {
      const years = await configProvider.getYearByLevelIds(level_id);
      this.years = years;
    },

    async update_year() {
      const ref_data_year_semester = getById(
        this.years,
        this.year_id,
        "YEAR_ID"
      );
      this.year = ref_data_year_semester.YEAR;
      this.semester = ref_data_year_semester.SEMESTER;
    },

    async confirm_gen_student_id() {
      let response = null;
      if (
        (this.mode_id == "real" && this.student_id_data_num) ||
        this.mode_id == "check"
      ) {
        response = await genericProvider.genStudentId({
          level: this.level_id,
          year: this.year,
          semester: this.semester,
          mode: this.mode_id,
          format: "json",
        });
        if (this.mode_id == "check") {
          this.student_id_head = response.header;
          this.json_fields = Object.assign({}, this.student_id_head);
          this.json_fields = Object.assign(
            {},
            ...Object.entries(this.json_fields).map(([a, b]) => ({ [b]: a }))
          );
          this.student_id_data = response.data;
          if (this.student_id_data.length != 0) {
            this.student_id_data_num = this.student_id_data.length;
          } else {
            this.$toasted.error("ไม่พบข้อมูลผู้สมัครที่รอการสร้างรหัส");
            this.student_id_data = null;
          }
          this.json_data = this.student_id_data;
        } else {
          if (response.updated == this.student_id_data_num) {
            this.$toasted.success(
              "Update sucessfully " + response.updated + " คน",
              {
                duration: 0,
              }
            );
            this.student_id_data = null;
          } else {
            this.$toasted.error(
              "Update เพียง " + response.updated + " คน (ไม่ครบ)"
            );
          }
        }
      } else {
        this.$toasted.error("กด Mode: 1.ตรวจสอบการสร้างรหัส ก่อน");
      }
    },

    startDownload() {
      alert("show loading");
    },
    finishDownload() {
      alert("hide loading");
    },

    //=============== Gen student ID 4+1=========================
    async get_register_details() {
      const register_uid = await configProvider.getUIDbyRegisterID(
        parseInt(this.register_id)
      );
      this.register_uid = register_uid.UID;

      const data_matriculation = await configProvider.getMatriculationStatus(
        this.register_uid
      );
      this.martriculation_student_status =
        data_matriculation.MATRICULATION_STATUS_ID == 3
          ? "รายงานตัวสำเร็จ"
          : "ยังไม่รายงานตัว/รายงานตัวไม่ผ่าน";

      const data = await authProvider.getUserInfo(this.register_uid);
      this.UserInfo_nameTh = data.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameTh = data.admission.STUDENT_LNAME_TH;

      const registerData = await payInSlipService.getPaymentApplicationFee(
        parseInt(this.register_id)
      );
      this.register_level_id = registerData.level_id;
      this.register_level_name_th = registerData.level_name_th;
      this.register_level_name_en = registerData.level_name_en;
      this.register_project = registerData.project_name_th;
      this.register_curriculum = registerData.register_curriculum;
      this.register_curriculum_id_old =
        registerData.register_curriculum[0].admission_curriculum_id;
      // เอา register curr old ไปหา masterreg curr id จากนั้นเอา master regcurr ไปหาในตาราง curriculum เพื่อให้ได้ registrarกับ faculty id ออกมา
      this.register_project_id_old = registerData.project_id;
      if (!this.register_curriculum[0].specific_nation_name_th) {
        this.register_curriculum[0].specific_nation_name_th = "ไม่ระบุ";
      }
      this.register_curriculum_full =
        " " + this.register_curriculum[0].curriculum_name_th;
      if (this.register_level_id == 2 || this.register_level_id == 3) {
        +" => " +
          this.register_curriculum[0].study_plan_name_th +
          " | ประเภทรับเข้า : " +
          this.register_curriculum[0].study_admit_type_name_th +
          " | ช่วงเวลาเรียน : " +
          this.register_curriculum[0].study_classes_name_th +
          " | เฉพาะสัญชาติ : " +
          this.register_curriculum[0].specific_nation_name_th;
      }
    },
    async get_all_gen_student_id_to() {
      // const ref_faculty = getById(
      //   this.registrar_faculties,
      //   this.registrar_faculty_id,
      //   "faculty_id"
      // );
      const ref_curriculum = getById(
        this.registrar_curriculums,
        this.registrar_curriculum_id,
        "curriculum_id"
      );
      const ref_data_study_plan = getById(
        this.study_plans,
        this.study_plan_id,
        "STUDY_PLAN_ID"
      );
      this.CURRICULUM_NAME_TO =
        // "คณะ " +
        // ref_faculty.faculty_name_th +
        // "สาขา " +
        ref_curriculum.curriculum_name_th +
        " (" +
        ref_data_study_plan.STUDY_PLAN_NAME_TH +
        " )";

      this.open_lock_confirm = true;
    },

    async confirm_gen_student_id_graduate() {
      const response = await configProvider
        .setGenStudentId({
          register_id: this.register_id,
          student_id: this.student_id,
          admis_year: this.year_graduate,
          admis_term: this.semester_graduate,
          faculty_id: this.registrar_faculty_id,
          curr_id: this.registrar_curriculum_id,
          curr2_name: this.CURRICULUM_NAME_TO,
          level_id: this.level_id_graduate,
          study_plan_id: this.study_plan_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message));
        });
      if (response.status) {
        this.$toasted.success("Insert successfully");
      }
      this.register_id = null;
      this.UserInfo_nameTh = null;
      this.UserInfo_surnameTh = null;
      this.register_project = null;
      this.register_level_name_th = null;
      this.register_level_name_en = null;
      this.register_curriculum = null;
      this.register_curriculum_full = null;
      this.level_id_graduate = null;
      this.level_id_fake = null;
      this.year_graduate = null;
      this.semester_graduate = null;
      this.student_id = null;
      this.study_plan_id = null;
      this.open_lock_confirm = false;
      this.register_level_id = null;
      this.registrar_faculty_id = null;
      this.registrar_curriculum_id = null;
      this.CURRICULUM_NAME_TO = null;
    },

    async update_study_plan() {
      this.level_id_fake =
        this.level_id_graduate === "4" || this.level_id_graduate === "5"
          ? "2"
          : this.level_id_graduate;
      const studyplans = await refProvider.getStudyPlans();
      this.study_plans = studyplans.filter(
        (item) => item.LEVEL_ID === this.level_id_fake
      );
    },
    //===========================================================
    async update_faculty(level_id_graduate, registrar_faculty_id) {
      this.level_id_fake =
        level_id_graduate === "4" || level_id_graduate === "5"
          ? "2"
          : level_id_graduate;
      const curriculums = await centralService.getRegistrarCurriculum(
        this.level_id_fake,
        registrar_faculty_id
      );
      this.registrar_curriculums = curriculums;
      this.registrar_curriculum_id = null;
    },
    //===========================================================
    async update_level_graduate(group_level_id) {
      this.group_year_id = null;
      const group_years = await configProvider.getYearByLevelIds(
        group_level_id
      );
      this.group_years = group_years;
      this.group_round_id = null;
      this.group_project_id = null;
      this.group_curriculum_id = null;
    },

    async update_year_graduate(group_year_id) {
      this.group_round_id = null;
      const group_rounds = await configProvider.getFilteredRounds(
        group_year_id
      );
      this.group_rounds = group_rounds.filter(
        (item) => item.LEVEL_ID === this.group_level_id
      );
      this.group_project_id = null;
      this.group_curriculum_id = null;
    },

    async update_round(group_year_id) {
      this.group_project_id = null;
      const group_projects = await configProvider.getFilteredProjects(
        group_year_id
      );
      this.group_projects = group_projects.filter(
        (item) => item.ROUND_ID === this.group_round_id
      );
      this.group_curriculum_id = null;
    },

    async update_project(group_year_id) {
      this.group_curriculum_id = null;
      const group_curriculums = await configProvider.getFilteredCurriculums(
        group_year_id
      );
      this.group_curriculums = group_curriculums.filter(
        (item) => item.PROJECT_ID === this.group_project_id
      );
    },

    async init_data() {
      const faculties = await centralService.getRegistrarFaculty();
      this.registrar_faculties = faculties;

      const group_levels = await refProvider.getLevel();
      this.group_levels = group_levels;
    },
  },
  mounted: function () {
    this.init_data();
  },
};
</script>
